import { render, staticRenderFns } from "./UUID.vue?vue&type=template&id=61b3aa6d&"
import script from "./UUID.vue?vue&type=script&lang=js&"
export * from "./UUID.vue?vue&type=script&lang=js&"
import style0 from "./UUID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports